/* eslint-disable react/no-danger */
import _ from 'lodash';
import PropTypes from 'prop-types';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withDigitalData } from '../../../utils/DigitalDataContext';
import { withLabels } from '../../../utils/LabelsContext';
import Tooltip, { TooltipText } from '../../ui/Tooltip/Tooltip';
import { getTooltipText } from '../helpers';
import { useSellerInfo } from '../hooks/useSellerInfo';
import { SellerInfoDesktopStyle } from './SellerInfoDesktop.style';

const SellerInfoDesktop = ({ product, labels, appCtx, digitalData }) => {
  const sellerInfo = useSellerInfo({ product, appCtx, digitalData });

  if (!sellerInfo.shouldRender) {
    return null;
  }

  const { validatedSellerName, sellerClass, sellerLink, isOutOfStock, isSellerPopupEnabled } = sellerInfo;

  return (
    <div className={`sellerText rebranded ${isOutOfStock && 'out-of-stock'}`}>
      <div className="sellerInfoContainer fa--seller-info__desktop">
        <span>{labels.SELLER_SOLD_BY}&nbsp;</span>
        {sellerClass ? <span className={`${sellerClass}Icon`} /> : null}
        <a id="testId-SellerInfo-sellerName" href={sellerLink} className="link">
          <span className="underline">{validatedSellerName}</span>
        </a>
        {isSellerPopupEnabled && (
          <Tooltip
            position="bottom-middle"
            hasCaret
            tooltipContent={
              <TooltipText
                text={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getTooltipText({
                        sellerName: sellerClass || sellerInfo.sellerNameLower,
                        labels,
                        storePlaceholderText: constants.STORE_PLACEHOLDER,
                        sellerData: product.sellerInfo,
                        isNational: !_.get(product, 'internationalShipping.applicable', false),
                      }),
                    }}
                    id="seller-tooltip-text"
                  />
                }
                viewType="medium"
              />
            }
          >
            <i className="csicon-alert alertIcon">
              <span className="sr-only">Seller Info</span>
            </i>
          </Tooltip>
        )}
      </div>
      <style jsx>{SellerInfoDesktopStyle}</style>
    </div>
  );
};

SellerInfoDesktop.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  digitalData: PropTypes.object.isRequired,
};

export { SellerInfoDesktop };
export default withApplicationContext(withLabels(withDigitalData(SellerInfoDesktop)));
